import MailboxReports from './mailbox-reports';

export default MailboxReports;
